if (!customElements.get('size-guide-popup')) {
  class SizeGuidePopup extends HTMLElement {
    constructor() {
      super();
      const popupId = this.getAttribute('data-handle');
      const popup = document.querySelector(`.button--tab[data-type="${popupId}"]`);
      if (!popup) {
        this.remove();
        return;
      }
      this.addEventListener('click', this.openPopup.bind(this));
    }

    openPopup() {
      const popupId = this.getAttribute('data-handle');
      if (!popupId) return;

      const popup = document.querySelector(`.button--tab[data-type="${popupId}"]`);
      if (!popup) return;

      popup.scrollIntoView({ behavior: 'smooth', block: 'center' });
      popup.click();
    }
  }

  customElements.define('size-guide-popup', SizeGuidePopup);
}
